// extracted by mini-css-extract-plugin
export default {"container":"Home_container__h5UCt","middle":"Home_middle__1iDf1","bold":"Home_bold__PrPS+"};